<template>
  <div>
    <div class="card preview">
      <div class="card-title">EXCERPT PREVIEW</div>
      <div class="ad-preview">
        <img class="bg-image" src="/assets/img/iphone_6.png" />
        <img class="map-image" src="/assets/img/ad-excerpt.png" />
        <div class="preview-excerpt">
          <img :src="ad.tooltipImage" />
          <div class="ad-text">
            <div class="ad-text-title">{{ ad.tooltipTitle }}</div>
            <div class="ad-text-message">{{ ad.tooltipDescription }}</div>
          </div>
          <i class="fa fa-chevron-right"></i>
        </div>
      </div>
    </div>

    <div class="card preview">
      <div class="card-title">CONTENT PREVIEW</div>
      <div class="ad-preview">
        <img class="bg-image" src="/assets/img/iphone_6.png" />
        <img class="map-image" src="/assets/img/ad-content.png" />
        <div class="ad-title">{{ ad.mainHeader }}</div>
        <div class="ad-container">
          <div class="ad-content">
            <img class="ad-image" :src="ad.mainImage" />
            <div class="ad-content-title">{{ ad.mainTitle }}</div>
            <div class="ad-content-body" v-html="ad.mainBody"></div>
            <a class="ad-cta" href="javascript:;">{{ ad.ctaText }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'consumer-ad-preview',
  computed: {
    ad () { return this.$store.state.ads.adItem.edited }
  }
}
</script>

<style lang="scss" scoped>
.card {
  padding: 15px;
  margin-top: 15px;
}
.card-title{
  font-weight: 700;
  font-size: 12px;
  color: #0D79F2
}

.ad-preview{
  position: relative;

  .bg-image {
    width: 300px;
    margin: 10px auto 0;
    display: block;
  }

  .map-image {
    position: absolute;
    top: 76px;
    left: 105px;
    width: 259px;
    height: 461px
  }
}

.preview-excerpt {
  position: absolute;
  bottom: 101px;
  left: 115px;
  width: 239px;
  height: 49px;
  border-radius: 3px;
  background-color: #fff;
  & img {
    position: absolute;
    top: 7px;
    left: 7px;
    width: 35px;
  }

  & .ad-text {
    margin-left: 49px;
    margin-right: 22px;
    padding: 11px 0;
  }

  & .ad-text-title {
    font-weight: 400;
    font-size: 11px;
    white-space: nowrap; 
    overflow: hidden;
    text-overflow: ellipsis;
    color: #F20D5E;
    margin-top: -1px;
  }

  & .ad-text-message {
    font-size: 9px;
    white-space: nowrap; 
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: -1px;
  }

  & i {
    display: block;
    position: absolute;
    top: 18px;
    right: 8px;
    color: #999;
    font-size: 11px;
  }
}

.ad-title {
  position: absolute;
  top: 84px;
  left: 140px;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  width: 200px;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
}

.ad-container {
  position: absolute;
  top: 115px;
  left: 105px;
  width: 259px;
  height: 422px;
}

.ad-content {
  overflow: auto;
  height: 100%;
}
.ad-image {
  display: block;
  width: 259px;
}
.ad-content-title {    
  font-weight: 400;
  font-size: 11px;
  color: #F20D5E;
  padding: 8px 5px;
  text-align: center;
}
.ad-content-body{
  text-align: justify;
  padding: 0 8px;
  font-size: 9px;
}
.ad-cta {
  background-color: #009688;
  font-weight: 400;
  font-size: 11px;
  color: #fff;
  text-decoration: none;
  display: block;
  text-align: center;
  padding: 6px;
  margin: 8px;
  border-radius: 3px;
  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
}

@media screen and (max-width: 430px) {
 .preview-excerpt {
   position: relative;
   left: 0;
   width: 240px;
   margin: 0 auto;
   bottom: 73px;
 }

 .preview {
   padding-bottom: 100px;
   &:last-child {
    margin-bottom: 60px;
   }
 }

 .ad-title {
   left: 80px;
 }

 .ad-preview {
  margin-bottom: 20px;
   .map-image, .ad-container {
    display: block;
    position: relative;
    top: 0;
    left: 0;
    height: 461px;
    width: 260px;
    margin: 0 auto;
    margin-top: -537px;
   }

   .ad-container {
     margin-top: -422px;
     height: 422px;
   }
 }
}
</style>



// WEBPACK FOOTER //
// src/components/MarketingAds/ConsumerAdPreview.vue